<template>
  <div class="addclient">
    <div class="card">
      <div class="card-header">
        Registrace klienta
      </div>
      <div class="card-block">
          <form v-if="!waitForData" @submit.prevent="submitForm">
            <div class="row justify-content-center">
              <div class="form-group col-md-4">
                <strong>Přidání adresy:</strong>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="form-group col-md-4">
                <label for="street">Ulice a čp.:</label>
                <input v-model="address.street" type="text" class="form-control" aria-describedby="streetHelp" id="street">
                <small id="streetError" class="form-text text-danger" v-if="addressError.street">{{ addressError.street.message }}</small>
              </div>
              <!--<div class="form-group col-md-1">
                <label for="houseNumber">Čp.:</label>
                <input v-model="address.house_number" type="text" class="form-control" aria-describedby="houseNumberHelp" id="houseNumber">
                <small id="housenumberError" class="form-text text-danger" v-if="addressError.housenumber">{{ addressError.housenumber.message }}</small>
              </div>-->
            </div>
            <div class="row justify-content-center">
              <div class="form-group col-md-2">
                <label for="city">Město:</label>
                <input v-model="address.city" type="text" class="form-control" aria-describedby="cityHelp" id="city">
                <small id="cityError" class="form-text text-danger" v-if="addressError.city">{{ addressError.city.message }}</small>
              </div>
              <div class="form-group col-md-2">
                <label for="zipcode">PSČ:</label>
                <input v-model="address.zip_code" type="text" class="form-control" aria-describedby="zipcodeHelp" id="zipcode">
                <small id="zipcodeError" class="form-text text-danger" v-if="addressError.zipcode">{{ addressError.zipcode.message }}</small>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="form-group col-md-4">
                <label for="country">Země:</label>
                <div class="input-group">
                  <select v-model="address.country" class="form-control" aria-describedby="countryHelp" id="country">
                    <option v-for="row in countries" v-bind:value="row.id">{{ row.name }}</option>
                  </select>
                  <small id="countryError" class="form-text text-danger" v-if="addressError.country">{{ addressError.country.message }}</small>
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="form-group col-md-4">
<!--
                <button v-if="!waitForResponse" type="submit" v-on:click="submitForm" class="btn btn-primary">Zaregistrovat klienta</button>
-->
                <button v-if="addressPending === false" type="submit" class="btn btn-primary">Přidat adresu</button>
                <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
              </div>
            </div>
          </form>
        <div  v-if="waitForData" class="row justify-content-around">
          <div class="">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import auth from '../../auth'
  // import error from '../../error'

  export default {
    data () {
      return {
        // client
        addressError: {},
        addressPending: false,
        address: {
          city: '',
          street: '',
          // house_number: '',
          zip_code: '',
          country: 1
        },
        // others
        setting: require('../../variables.js'),
        waitForResponse: false,
        waitForData: false,
        message: '',
        submited: '',
        countries: [],
        citizenship: [],
        healthinsurance: []
      }
    },
    methods: {
      submitForm () {
        this.postAddress()
        /* if (!this.clientCreated) {
         } else {
          this.putClient()
          if (!this.addressCreated) {
            this.postAddress()
          } else {
            this.putAddress()
          }
        } */
      },
      getCountries () {
        this.waitForData = true
        this.$http.get(this.setting.hostname + 'country').then(response => {
          this.countries = response.data
          // this.useGovData = true
          this.waitForData = false
        }, response => {
          this.waitForData = false
        })
      },
      postAddress () {
        this.addressPending = true
        this.$http.post(this.setting.hostname + 'client/' + this.$route.params.clientid + '/address', this.address, {emulateJSON: true}).then(response => {
          this.submited = response.data
          this.addressPending = false
          // this.$router.push({name: 'AddAddress', params: { clientid: response.data.id }})
          // this.$route.push()
        }).catch(error => {
          this.addressError = error.response.data.errors
          this.addressPending = false
        })
      }
    },
    beforeMount () {
      this.getCountries()
    },
    watch: {
      //
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.icon-male {
  color: dodgerblue;
  font-weight: bold;
}

.icon-female {
  color: deeppink;
  font-weight: bold;
}

.icon-genderless {
  color: #ccc;
  font-weight: bold;
}

.table > tbody > tr > td, .table > tfoot > tr > td {
  vertical-align: middle;
}

.table > tbody > tr > td, .table > tfoot > tr > td {
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/views/Client/AddAddress.vue?26c317ab